import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "mb-3 small" };
const _hoisted_3 = { class: "row align-middle" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "col-sm-7" }, null, -1);
const _hoisted_5 = { class: "col-sm-5 text-end pl-0" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "row mb-2" };
const _hoisted_8 = {
    class: "col-md-12 text-muted",
    style: { "font-size": ".8em" }
};
const _hoisted_9 = {
    key: 0,
    class: "mb-3 error__message-container"
};
const _hoisted_10 = { class: "row align-middle" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "col-sm-7" }, null, -1);
const _hoisted_12 = { class: "col-sm-5 text-end pl-0" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_simple_page = _resolveComponent("g-simple-page");
    return (_openBlock(), _createBlock(_component_g_simple_page, {
        title: _ctx.$host.pageMeta.title,
        "back-link-path": "/login"
    }, {
        default: _withCtx(() => [
            (_ctx.$route.hash == '#submit')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$tc('account.Login.Reset.Success.Message')), 1),
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_g_button, {
                                text: _ctx.$tc('account.Back'),
                                onClick: _ctx.OnBack,
                                "button-style": "btn-outline-secondary"
                            }, null, 8, ["text", "onClick"])
                        ])
                    ])
                ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                        _createVNode(_component_g_text_field, {
                            dataObject: _ctx.$data,
                            "data-member": "password1",
                            "data-mode": "model",
                            label: _ctx.$tc('account.Password.Reset.Password') + '*',
                            mode: "password",
                            onEnterKey: _ctx.OnExecute
                        }, null, 8, ["dataObject", "label", "onEnterKey"]),
                        _createVNode(_component_g_text_field, {
                            dataObject: _ctx.$data,
                            "data-member": "password2",
                            "data-mode": "model",
                            label: _ctx.$tc('account.Password.Reset.Confirm') + '*',
                            mode: "password",
                            onEnterKey: _ctx.OnExecute
                        }, null, 8, ["dataObject", "label", "onEnterKey"]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$tc('account.Password.Note')), 1)
                        ]),
                        (_ctx.hasError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.errorMessage), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_g_button, {
                                text: _ctx.$tc('account.Login.Reset.Execute'),
                                disabled: _ctx.disableLogin,
                                onClick: _ctx.OnExecute
                            }, null, 8, ["text", "disabled", "onClick"])
                        ])
                    ])
                ]))
        ]),
        _: 1
    }, 8, ["title"]));
}
